import React from 'react';
import styled from 'styled-components';
import { black } from '@spotify-internal/encore-foundation';
import { TableHeaderCell as THC } from '@spotify-internal/encore-web';
import { Link } from 'react-router-dom';

export function TableHeaderLabel({
  active,
  label,
  childrenOrderedFirst = true,
  children,
  style,
}: {
  active?: boolean;
  label: string;
  childrenOrderedFirst?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  const Label = styled.div`
    align-items: center;
    display: flex;
    justify-content: flex-end;
    color: ${active ? black : ''};

    svg {
      margin: -2px 0 0;
    }

    &:hover {
      color: ${black};
    }
  `;

  return (
    <Label style={style}>{childrenOrderedFirst ? [children, label] : [label, children]}</Label>
  );
}

export const TableHeaderCell = styled(THC)`
  cursor: default;
`;

export const TableRowLink = ({ to, ...linkProps }) => {
  const StyledLink = styled(Link)`
    color: ${black};
    font-weight: 600;
  `;

  return (
    <StyledLink
      {...linkProps}
      to={to}
      onClick={/* istanbul ignore next */ e => e.stopPropagation()}
    />
  );
};
